import React from 'react'

const SongwriterCatalogBuilderHeader = () => (
    <>
        <p>
            Enter the name you wish to search in the Writer Name field, then click the <strong>Search</strong> button.
            From the results, select all versions of the writer name you have the rights to by clicking the{' '}
            <strong>Add to Catalog</strong> toggle, which will change to <strong>In Catalog</strong> once the writer
            name has been added.
        </p>
        <br />
        <p>
            NOTE: Before adding a name to your catalog, please confirm it is the correct writer name by reviewing the
            associated IPI Number or by clicking the blue link showing the number of titles, which will show you songs
            associated with that name.
        </p>
    </>
)

export default SongwriterCatalogBuilderHeader
